import { EstadoServidor } from "../../bussines/entities/EstadoServidor.entity";
import { EstadoServidorDtSource } from "../../bussines/dataSources/EstadoServidorDtSource";
import { Recurso } from 'lib.common/dist/CleanArch';
import { transformacion } from 'lib.common';
import { urls } from "src/config/keys";
import { ErrExterno } from 'lib.common/dist/errorHandler';

export class EstadoServidorDtSourceImplRest implements EstadoServidorDtSource {
    private apikey: string;
    constructor(apikey: string) {
        this.apikey = apikey;
    }
    async getEstadoServidores(): Promise<Recurso<EstadoServidor[]>> {
        try {
            let url = transformacion.appendUrl(urls.backEnd, `/servidor/estadoServidores`);
            console.log(url);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `Error en la petición del servidor.`);
            }

            const data: EstadoServidor[] = await response.json();
            return Recurso.fromData<EstadoServidor[]>(data);
        } catch (error) {
            return Recurso.fromError<EstadoServidor[]>(new ErrExterno(error as Error));
        }
    }
}